export enum EFlightPhysicalTypes {
  NOT_SCHEDULED = 'NOT SCHEDULED',
  SCHEDULED = 'SCHEDULED',
  COMPLETE = 'COMPLETE',
  CERTIFIED = 'CERTIFIED',
  DISQUALIFIED = 'DISQUALIFIED'
}
